import project, { dialogCreator as projectDialogCreator } from './project';
import tract, { dialogCreator as tractDialogCreator } from './tract';
import nav, { dialogCreator as navDialogCreator } from './nav';
import leasehold, { dialogCreator as leaseholdDialogCreator } from './leasehold';
import common, { dialogCreator as commonDialogCreator } from './common';
import contract, { dialogCreator as contractDialogCreator } from './contract';
import owners, { dialogCreator as ownerDialogCreator } from './owners';
import processing, { dialogCreator as processingDialogCreator } from './processing';
import settings, { dialogCreator as settingsDialogCreator } from './settings';

export type dialogCreators = {
    beginHide: boolean;
    hideDialog: () => void;
    common: commonDialogCreator;
    project: projectDialogCreator;
    tract: tractDialogCreator;
    nav: navDialogCreator;
    leasehold: leaseholdDialogCreator;
    contract: contractDialogCreator;
    owners: ownerDialogCreator;
    processing: processingDialogCreator;
    settings: settingsDialogCreator;
};

const creators = (setDialog: (element: React.ReactElement) => void, hideDialog: () => void, beginHide: boolean): dialogCreators => {
    return {
        beginHide,
        hideDialog,
        common: common(setDialog),
        project: project(setDialog),
        tract: tract(setDialog),
        nav: nav(setDialog),
        leasehold: leasehold(setDialog),
        contract: contract(setDialog),
        owners: owners(setDialog),
        processing: processing(setDialog),
        settings: settings(setDialog),
    };
};

export default creators;



// WEBPACK FOOTER //
// ./src/providers/dialogs/index.ts